import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery, transformErrorResponse, transformErrorResponseWithMessage, transformResponse } from "../../baseQuery";

export const StudyHealthCoverApiSlice = createApi({
    reducerPath: "StudyHealthCoverApiSlice",
    baseQuery,

    tagTypes: ["healthCover"],

    endpoints: (builder) => ({

        getHealthCoverPageUserApi: builder.query({
            query: ({destFilterid}) => ({
                url: 'healthCover/getHealthCoverPageUser',
                method: "GET",
                params:{destFilterid}
            }),
            transformResponse,
            transformErrorResponse: transformErrorResponseWithMessage,
            providesTags: ["healthCover"]
        }),

    }),
});

export const {
    useGetHealthCoverPageUserApiQuery
} = StudyHealthCoverApiSlice; 